import { createAction, props } from "@ngrx/store";
import { Hsn } from "app/modules/masters/hsn-code/model/hsn.model";

// Load HSN Codes
export const loadHsns = createAction("[HSN] Load HSN");

export const loadHsnSuccess = createAction(
  "[HSN] Load HSN Success",
  props<{ hsn: Hsn[] }>()
);

export const loadHsnFailure = createAction(
  "[HSN] Load HSN Failure",
  props<{ error: string }>()
);

// Create HSN Code
export const createHsn = createAction(
  "[HSN] Create HSN",
  props<{ hsn: Hsn }>()
);

export const createHsnSuccess = createAction(
  "[HSN] Create HSN Success",
  props<{ hsn: Hsn }>()
);

export const createHsnFailure = createAction(
  "[HSN] Create HSN Failure",
  props<{ error: string }>()
);

// Deactivate HSN Code
export const deactivateHsn = createAction(
  "[HSN] Deactivate HSN",
  props<{ id: string }>()
);

export const deactivateHsnSuccess = createAction(
  "[HSN] Deactivate HSN Success",
  props<{ id: string }>()
);

export const deactivateHsnFailure = createAction(
  "[HSN] Deactivate HSN Failure",
  props<{ error: string }>()
);

// Delete HSN Code
export const deleteHsn = createAction(
  "[HSN] Delete HSN",
  props<{ id: string }>()
);

export const deleteHsnSuccess = createAction(
  "[HSN] Delete HSN Success",
  props<{ id: string }>()
);

export const deleteHsnFailure = createAction(
  "[HSN] Delete HSN Failure",
  props<{ error: string }>()
);
